function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { LI } from './styles';
const TRow = props => {
  const {
    theme,
    selectedTheme,
    headerTextColor,
    headerBGColor,
    hasLabel,
    labelBGColor,
    evenTextColor,
    evenBGColor,
    evenHoverTextColor,
    evenHoverBGColor,
    oddTextColor,
    oddBGColor,
    oddHoverTextColor,
    oddHoverBGColor,
    header,
    children,
    callback,
    provided,
    columnLayout,
    headers,
    mobileSize
  } = props;
  return /*#__PURE__*/React.createElement(LI, _extends({
    ref: provided?.innerRef,
    $theme: theme,
    $selectedTheme: selectedTheme,
    $headerTextColor: headerTextColor,
    $headerBGColor: headerBGColor,
    $header: header,
    $headers: headers,
    $hasLabel: hasLabel,
    $labelBGColor: labelBGColor,
    $evenTextColor: evenTextColor,
    $evenBGColor: evenBGColor,
    $evenHoverTextColor: evenHoverTextColor,
    $evenHoverBGColor: evenHoverBGColor,
    $oddTextColor: oddTextColor,
    $oddBGColor: oddBGColor,
    $oddHoverTextColor: oddHoverTextColor,
    $oddHoverBGColor: oddHoverBGColor,
    $callback: callback,
    $columnLayout: columnLayout,
    $mobileSize: mobileSize,
    onClick: () => callback?.()
  }, provided?.draggableProps, provided?.dragHandleProps), children);
};
export { TRow };